import { Controller } from '@hotwired/stimulus'
import { jquery } from 'utils/jquery'

// #AI: EB (ElectionBuddy) and NProgress are loaded via Sprockets as global variables
const EB = window.EB;
const NProgress = window.NProgress;

export default class extends Controller {
  connect() {
    if (!EB || !EB.Elections) {
      console.error('[WriteInDropController] EB not available');
      return;
    }
    
    // jQuery UI droppable is not available on admin pages — skip silently
    const $ = jquery();
    if (!$ || typeof $.fn.droppable !== 'function') return;

    const Elections = EB.Elections;
    if (Elections.Results.pageRequiresDragAndDropFeature(document.body)) {
      Elections.Results.initWriteInDrop(this.element)
    }
  }

  startSpinner() {
    if (NProgress) {
      NProgress.start()
    }
  }

  stopSpinner() {
    NProgress.done()
  }
}
